<script setup lang="ts">
import { ref } from "vue";
import { VideoModal } from "@/ts/components/elements";

let show = ref(false);

const modal = ref({ open: false });

interface Props {
    vimeoId: string | number;
}

defineProps<Props>();
</script>

<template>
    <transition name="fade" appear>
        <button
            title="video afspelen"
            @click.prevent="modal.open = true"
            class="hover:bg-gray-200 absolute bottom-1 right-10 flex h-[3.75rem] w-[3.75rem] items-center justify-center rounded-full bg-white text-pink drop-shadow transition-all hover:scale-110 hover:drop-shadow-lg md:bottom-11 md:h-20 md:w-20"
        >
            <svg class="h-auto w-4 md:w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path fill="currentColor" d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z" />
            </svg>
        </button>
    </transition>
    <video-modal ref="modal" :open="show">
        <div class="relative">
            <div class="relative pt-[56.25%]">
                <iframe class="absolute inset-0 h-full w-full" :src="`https://player.vimeo.com/video/${vimeoId}?autoplay=1&loop=true&portrait=false&title=false`" allowtransparency allow="autoplay; fullscreen"></iframe>
            </div>
        </div>
    </video-modal>
</template>

<style lang="scss" scoped></style>
